// In-memory ring buffer of recent JS errors, attached to feedback reports so a bug description
// can come with an actual stack trace instead of just "something broke". Session-only — no
// localStorage, no need to survive a reload.
import { clientLog } from "./clientLog.js";

const MAX_ERRORS = 10;
const buffer = [];

function push(entry) {
  buffer.push({ ...entry, at: new Date().toISOString() });
  if (buffer.length > MAX_ERRORS) buffer.shift();
  clientLog.error("app", entry.message || "Неизвестная ошибка интерфейса", { source: entry.source, stack: entry.stack });
}

let installed = false;
export function installErrorLog() {
  if (installed) return;
  installed = true;
  window.addEventListener("error", (e) => {
    push({ message: e.message, source: e.filename ? `${e.filename}:${e.lineno}:${e.colno}` : null, stack: e.error?.stack || null });
  });
  window.addEventListener("unhandledrejection", (e) => {
    const reason = e.reason;
    // An expired or revoked session (idle auto-logout, a wake-up after hours): AuthContext's
    // interceptor already sends the operator to the login screen, so this is not an app error.
    if (reason?.response?.status === 401) return;
    push({ message: reason?.message || String(reason), stack: reason?.stack || null, source: "unhandledrejection" });
  });
}

export function getRecentErrors() {
  return buffer.slice();
}
